var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
import { translate } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import { toJSTransformer as toJS } from 'framework/utils/CommonUtils';
import { isMobileOnly } from 'react-device-detect';
import qs from 'qs';
import _get from 'lodash/get';
import Page from '../../containers/Page';
// md3 step content + chrome (same checkoutStore + same props as the retired legacy components).
import ContactInformationNext from './CheckoutStepper/Content/ContactInformation/ContactInformationNext';
import PaymentTypeNext from './CheckoutStepper/Content/PaymentType/PaymentTypeNext';
import PaymentDetailsNext from './CheckoutStepper/Content/PaymentDetails/PaymentDetailsNext';
import AdditionalServicesNext from './CheckoutStepper/Content/AdditionalServices/AdditionalServicesNext';
import DeliveryServicesNext from './CheckoutStepper/Content/AdditionalServices/DeliveryServicesNext';
import OrderOverviewNext from './CheckoutStepper/Content/OrderOverview/OrderOverviewNext';
import { CheckoutTopBarNext, CheckoutHeaderNext, CheckoutStepperNext, CheckoutButtonNext, CheckoutAsideNext, CheckoutMobilePageTitle } from './CheckoutChromeNext';
import { ModalOverlay } from '../../modals';
import { Redirect } from 'react-router';
import { history } from '../../../AppRouter';
import styles from './CheckoutPage.styl';
import classnames from 'classnames';
import form, { fields } from './CheckoutStepper/Content/ContactInformation/formConfig';
import { default as borrowerForm, fields as borrowerFields } from './CheckoutStepper/Content/PaymentDetails/formConfig';
import { default as deliveryForm } from './CheckoutStepper/Content/AdditionalServices/formConfig';
import { default as orderOverviewForm } from './CheckoutStepper/Content/OrderOverview/formConfig';
import { checkoutSubStep, checkoutOffers as offers } from '@bytebrand/fe-ui-core-autobahn/constants';
import { getAnschlussGarantiePrice, getPersistedCheckoutResumeState } from '../../../stores/CheckoutStore';
import { PLACEHOLDER_IMAGE_SMALL_URL } from '../../../framework/constants/app';
import { getFormattedPrice } from '@bytebrand/fe-ui-core-autobahn/utils';
// import GoogleTagManager from '../../../services/GoogleTagManager';
// import config from '../../../../config/app.config';
// import UserActionsContactAPI from '../../../services/UserActionsContactAPI';
import { normalizeRateObject } from '@bytebrand/fe-financing';
import _ from 'lodash';
import UserActionsContactAPI from 'services/UserActionsContactAPI';
let CheckoutPage = class CheckoutPage extends React.Component {
    constructor(props) {
        super(props);
        // ADV-280: this redirect used to be a history.push inside render(). activeStep never changed,
        // so every push re-rendered the router, the render pushed again, and React bailed with
        // "Maximum update depth exceeded" (Safari: "pushState() more than 100 times") — a blank
        // checkout after a reload or back/forward onto a later step. Run it after the commit and move
        // the stepper back to step 0 as well, so it fires once.
        Object.defineProperty(this, "redirectToContactInformationIfIncomplete", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { checkoutStore } = this.props;
                const { isStepComplete, activeStep, readyToRedirect, isResumingCheckout, setActiveStep } = checkoutStore;
                if (readyToRedirect || isResumingCheckout || activeStep === 0 || isStepComplete('contact-information'))
                    return;
                const { externalState: { vatRate = 0, carId, mainImageId, make, model, subModel } } = checkoutStore;
                setActiveStep(0);
                this.props.history.replace({ state: { vatRate, carId, mainImageId, make, model, subModel }, pathname: `${checkoutStore.basePath}/contact-information` });
            }
        });
        Object.defineProperty(this, "handleBackButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { checkoutStore: { handleStep, steps, stepHasError, activeStep, subStep, popPrevLocations, prevLocations }, location: { pathname } } = this.props;
                const prevStep = prevLocations[prevLocations.length - 1];
                const newStep = steps.findIndex(item => item.pathname === prevStep);
                // ADV-279: no earlier checkout step to go back to (first step, or a reload emptied
                // prevLocations) — let the browser leave the checkout. This used to push the current step
                // back (Back never left step 1) and then call handleStep(-1), which threw on steps[-1].
                if (newStep === -1)
                    return;
                if (!stepHasError(activeStep, subStep)) {
                    popPrevLocations();
                }
                const isBackButton = true;
                handleStep(newStep, isBackButton)();
            }
        });
        Object.defineProperty(this, "handleChangePayment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                const { t, checkoutStore: { getCheckoutSteps, handleChangePayment } } = this.props;
                handleChangePayment(e);
                getCheckoutSteps(history, location, t);
            }
        });
        Object.defineProperty(this, "onCheckoutModalClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (modalContent, event) => {
                const { t, appStore: { showModal, hideModal, language } } = this.props;
                const { modalName } = modalContent;
                const modalProps = {
                    t, hideModal, modalName, language,
                    className: `${styles.financingModal} ${modalContent.className}`,
                    content: modalContent.content,
                    title: modalContent.title,
                    titleClassName: `${styles.modalTitle} ${modalContent.titleClassName}`,
                    isCheckoutViewModal: true,
                    overlayClassName: `${styles.modalWrapper} ${modalContent.modalWrapper}`,
                    showCloseButton: true,
                    contentClassName: styles.modalContent,
                    icon: modalContent.icon,
                    initialTab: modalContent.initialTab
                };
                showModal(modalName, modalProps);
            }
        });
        Object.defineProperty(this, "renderContent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (step) => {
                const { t, financingStore, checkoutStore, imagesStore, appStore: { language, showModal, hideModal }, carStore: { car }, profileStore, checkoutStore: { handleChangeStoreValue, addressField, offerIndex, subStep, registrationServicesOptions, warrantyPackage, anschlussGarantie, steps, ourTermsAndConditions, contactInformation: { firstName, lastName, street, number, zip, city }, externalState: { vatRate = 0, ownerId = '', carId, make, model, subModel, mainImageId, mlCurrentSalesPricePredicted } } } = this.props;
                const { getMaxFinancingFirstInstallment, setCommonUserConfig } = financingStore;
                const deliveryInformation = _.cloneDeep(profileStore.selectedDeliveryCheckoutAddressObj);
                const deliveryAddressCombined = `${firstName} ${lastName}, ${street} ${number}, ${zip}, ${city}`;
                const offerName = offers[offerIndex].name;
                const mainImageUrl = imagesStore.getSupportedImageFormat(carId, mainImageId, 'small');
                const mainImageTransparent = mainImageId ? imagesStore.getImageTransparent(carId, mainImageId) : PLACEHOLDER_IMAGE_SMALL_URL;
                const financingConfig = toJS(financingStore.getUserConfig(carId));
                const { [offerName]: { monthlyInstallment, transportationCost, withTransportation }, common: { currentSalesPrice } } = financingConfig;
                // Old logic dropped: this used to also add warrantyRate (legacy warrantyPackage pricing,
                // superseded by Anschluss-Garantie) and the Zulassungsservice/admission+plate registration
                // fees, which made order-overview's own "Monatlich zu zahlen" total diverge from the aside's
                // monthlyInstallment-only figure shown on every other step — order-overview's total should
                // be that same base rate, plus only the Anschluss-Garantie the customer actually chose.
                const checkoutTotalCost = getAnschlussGarantiePrice(anschlussGarantie, financingConfig, offerIndex);
                const offerConfig = financingConfig[offerName];
                const values = Object.keys(offerConfig).reduce((acc, key) => {
                    acc[key] = getFormattedPrice(offerConfig[key], '$,.2f');
                    return acc;
                }, {});
                let carObj = { ...car };
                if (car.price && car.price.currentSalesPrice && !car.rate.financing.monthlyInstallment) {
                    carObj = normalizeRateObject(car);
                }
                // get deliveryAddresses from profileStore fro step 4
                const getDeliveryAddreses = _get(profileStore, 'userProfile.deliveryAddresses', null);
                const { setDeliveryAddressesProfile, selectedDeiveryAddressValue, setDeliveryCheckoutAddressObj } = profileStore;
                // end
                const carObject = toJS(carObj) || {};
                const decoratedProps = carObject;
                const engineType = decoratedProps.consumption && decoratedProps.consumption.fuel;
                const properties = {
                    contactInformationProps: { form, language, fields },
                    paymentTypeProps: { checkoutStore, offerIndex, financingConfig, handleChangePayment: this.handleChangePayment },
                    additionalServicesProps: {
                        checkoutStore, financingConfig, offerName, vehicleId: carId, setCommonUserConfig, engineType,
                        location: this.props.location,
                        onCheckoutModalClick: this.onCheckoutModalClick,
                        transportationCost, withTransportation,
                        deliveryAddresses: getDeliveryAddreses,
                        setDeliveryAddressesProfile,
                        setDeliveryCheckoutAddressObj
                    },
                    paymentDetailsProps: {
                        checkoutStore, language, financingStore, borrowerForm, borrowerFields, values, financingConfig, offerName, deliveryAddressCombined,
                        vehicleId: carId,
                        mlCurrentSalesPricePredicted,
                        vehicleName: [make, model].filter(Boolean).join(' '),
                        maxFinancingFirstInstallment: carId ? getMaxFinancingFirstInstallment(carId) : 0
                    },
                    orderOverviewProps: {
                        checkoutStore, showModal, selectedDeiveryAddressValue, financingConfig, values, offerName, vatRate, orderOverviewForm,
                        addressField, mainImageUrl, mainImageTransparent, make, model, subModel, deliveryInformation, ownerId, checkoutTotalCost, language,
                        ourTermsAndConditions, selectedDeliveryCheckoutAddressObj: deliveryInformation, carObject: this.state.carInfo,
                        // ADV-299: this must equal the CDP's own rate (same as headerProps.price below) — no
                        // + checkoutTotalCost here. OrderOverviewNext.tsx folds checkoutTotalCost back in itself,
                        // locally, only for its own itemized breakdown card's total (mzzTotal), not this headline.
                        // Buy: currentSalesPrice (the plain base vehicle price, same field Card 5's own
                        // "Fahrzeugpreis" row and the price-rating bar already read), not currentSalesPriceExtra —
                        // that field bakes Rundum-Sorglos-Paket's cost in when the package is active, which
                        // double-counted it once on top of Card 5's own explicit "Rundum-Sorglos-Paket: inklusive"
                        // breakdown row.
                        price: (offerIndex === 3 ? currentSalesPrice : monthlyInstallment),
                        mlCurrentSalesPricePredicted,
                        onCheckoutModalClick: this.onCheckoutModalClick
                    },
                    deliveryServicesProps: {
                        setDeliveryAddressesProfile,
                        setDeliveryCheckoutAddressObj,
                        handleChangeStoreValue,
                        selectedDeiveryAddressValue,
                        transportationCost, showModal, withTransportation, offerIndex,
                        deliveryAddresses: getDeliveryAddreses,
                        onCheckoutModalClick: this.onCheckoutModalClick
                    }
                };
                const components = {
                    ContactInformation: ContactInformationNext,
                    PaymentType: PaymentTypeNext,
                    PaymentDetails: PaymentDetailsNext,
                    AdditionalServices: AdditionalServicesNext,
                    DeliveryServices: DeliveryServicesNext,
                    OrderOverview: OrderOverviewNext,
                };
                const stepObj = subStep ? checkoutSubStep : steps[step];
                const Component = components[stepObj.component];
                const props = properties[stepObj.props];
                return React.createElement(Component, { ...props, t });
            }
        });
        this.state = {
            carInfo: {}
        };
    }
    componentDidMount() {
        const { t, carStore, financingStore, appStore: { hideModal }, profileStore: { getFullUserProfile }, checkoutStore: { handleNext, getContactInformation, componentInitializeData, getCheckoutSteps, setReadyToRedirect, getOfferIndex, setActiveStep, setSavedCheckout, setExternalState, setOfferIndex, prevLocations, getCheckoutTermsAndCond, setResumingCheckout }, location: { state = {} } } = this.props;
        this.props.checkoutStore.setBasePath('/checkout');
        setActiveStep(this.props.activeStep || 0);
        window.addEventListener('popstate', this.handleBackButton);
        form.init(fields); // reset contact information input fields
        const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }) || {};
        // Read once, up front, before anything below can write to the SAME sessionStorage record —
        // setExternalState (called just below, and again inside the isSavedCheckout .then() further
        // down) has its own persistResumeState side effect that re-serializes checkoutStore's CURRENT
        // anschlussGarantie (still null this early — componentInitializeData hasn't run yet) back into
        // storage, which would clobber the real resumed value before componentInitializeData could
        // ever read it back. Capturing it here, before that first write, sidesteps the clobber.
        const resumedPersisted = getPersistedCheckoutResumeState();
        let resumedState = { ...state, ...params };
        // Entering a later step directly (reload, URL) keeps history.state from the earlier entry, so
        // location.state is not empty there. Resume the saved checkout instead of the first-visit branch.
        const isLaterStepEntry = (this.props.activeStep || 0) > 0;
        if (Object.keys(resumedState).length === 0 || isLaterStepEntry) {
            // resumedPersisted is the same carId (+ display fields) CheckoutStore.setExternalState just
            // mirrored into sessionStorage; passing it as isSavedCheckout routes through the resume branch
            // below, which reconstructs the full record and lastPathname for this step.
            if (resumedPersisted)
                resumedState = { ...resumedPersisted, isSavedCheckout: true };
        }
        setExternalState(resumedState);
        const { checkoutStore: { externalState } } = this.props;
        if (Object.keys(externalState).length === 0) {
            setReadyToRedirect(true);
            return;
        }
        if (externalState.isSavedCheckout) {
            setSavedCheckout(externalState.isSavedCheckout);
            setResumingCheckout(true);
            UserActionsContactAPI.getCheckoutCar(externalState.carId)
                .then(({ pathname, contactInformation, financingConfig, borrowerInformation, warrantyPeriod, warrantyPackage, isAdmissionService, isLicensePlateFee, isAllowYourself0, lastPathname, car }) => {
                this.setState({ carInfo: car });
                // 1st step data — the saved checkout record can exist (checkoutList.has(carId), e.g.
                // just from having opened step 1 before) with an EMPTY contactInformation, if the
                // customer never actually filled it in. Falls back to their own profile then, same as
                // the brand-new-checkout branch below (getFullUserProfile), instead of leaving the
                // form blank.
                if (contactInformation && Object.values(contactInformation).some((v) => !!v)) {
                    getContactInformation(contactInformation);
                }
                else {
                    getFullUserProfile().then(({ profile: { email, birthday, privateAddress = {} } }) => getContactInformation({ email, birthday, ...privateAddress }));
                }
                // 2nd step data — prefer the mode just picked on the VDP (externalState.offerIndex, a
                // live financingStore read at click time, see OfferRequestButtonWrapper.onClick) over
                // the SAVED record's own offerIndex, which can be stale relative to what was just
                // selected (e.g. an earlier abandoned Finanzierung attempt, now re-entered from a fresh
                // Leasing click).
                const resumedOfferIndex = externalState.offerIndex != null ? externalState.offerIndex : financingConfig.offerIndex;
                financingStore.setOfferIndex(resumedOfferIndex); // transform offerIndex and store in mobx
                const offerIndex = getOfferIndex();
                // 3rd step data
                const paymentDetailsOpen = !!borrowerInformation?.firstName;
                if (paymentDetailsOpen)
                    Object.entries(borrowerInformation).forEach(([key, value]) => {
                        borrowerForm.$(key).onChange(value, borrowerForm.$(key).name);
                    });
                financingStore.setUserConfig(externalState.carId, { ...financingConfig, offerIndex });
                // financingStore.setUserConfig(externalState.carId, financingConfig);
                // 4th step data
                setExternalState({ ...state, ...params, ownerId: car.metaData.ownerId });
                const registrationServicesOptions = [isAdmissionService, isLicensePlateFee, isAllowYourself0];
                componentInitializeData(registrationServicesOptions, offerIndex, borrowerInformation, paymentDetailsOpen, warrantyPackage, warrantyPeriod, this.props.checkoutStore.externalState, resumedPersisted?.anschlussGarantie);
                const steps = getCheckoutSteps(history, location, t);
                // The step the customer was actually on (kept live in sessionStorage) beats the server's
                // lastPathname, which only advances on "Weiter" and so lags behind a Back or a direct URL.
                const targetPathname = resumedPersisted?.lastPathname || lastPathname;
                // The route's own activeStep prop has already set activeStep to this URL's step before
                // the replay starts, and handleNext would then count from there — replay must start at 0.
                setActiveStep(0);
                if (targetPathname) {
                    for (let i = 0; i < steps.length; i++) {
                        // Check BEFORE calling handleNext, not after: once activeStep is already AT the
                        // saved step, no further advance is needed — an extra handleNext(true) here
                        // re-validates THAT step's own completeness (stepHasError), which the customer may
                        // legitimately not have finished yet (that's exactly why they saved here). That
                        // extra call was flipping showButtonErrorMessage true and showing "Please select a
                        // warranty option." the instant a saved checkout was reopened, before the customer
                        // had touched anything.
                        if (steps[i].pathname === targetPathname) {
                            break;
                        }
                        handleNext(true);
                    }
                }
                setResumingCheckout(false);
            }).catch(() => setResumingCheckout(false));
        }
        else if (externalState.carId) {
            // checkoutStore.offerIndex is only ever assigned once, in CheckoutStore.init() (reading
            // financingStore's offerIndex AT THAT MOMENT) — called from the constructor AND from
            // resetCheckoutStore() (componentWillUnmount, e.g. leaving checkout via the aside's
            // "Details" link back to the VDP). It is NEVER re-read afterward, so it stays frozen at
            // whatever mode was active when checkout was last EXITED — completely ignoring a new mode
            // picked on the VDP before clicking back in (see OfferRequestButtonWrapper.onClick, which
            // now carries that live selection through as externalState.offerIndex). Sync it here so
            // this (non-"isSavedCheckout") entry path reflects the mode just chosen.
            if (externalState.offerIndex != null) {
                financingStore.setOfferIndex(externalState.offerIndex);
                // getOfferIndex() (not the raw externalState.offerIndex) — checkoutOffers reorders
                // buy/abo relative to financingStore's own offers array (raw 2=buy/3=abo vs
                // checkout-space 2=abo/3=buy), same remap the isSavedCheckout branch above gets for
                // free by calling getOfferIndex() after financingStore.setOfferIndex(). Assigning the
                // raw value directly here left the Kaufen selection landing on the wrong (hidden abo)
                // card — ADV-250.
                setOfferIndex(getOfferIndex());
            }
            carStore.getCar(externalState.carId)
                .then((car) => {
                this.setState({ carInfo: car });
                let carObj = { ...car };
                if (car.price &&
                    car.price.currentSalesPrice &&
                    !financingStore.getUserConfig(externalState.carId).financing.monthlyInstallment) { // check if have got UPA data and normalized data
                    carObj = financingStore.normalizeRateObject(car);
                    carObj.rate.common.historyPriceDifference = car.price.historyPriceDifference;
                    carObj.rate.common.historyPriceDifferencePerCent = car.price.historyPriceDifferencePerCent;
                    financingStore.setUserConfig(externalState.carId, { ...carObj.rate });
                }
                setExternalState(externalState);
            });
            getFullUserProfile().then(({ profile: { email, birthday, privateAddress = {} } }) => getContactInformation({ email, birthday, ...privateAddress }));
            getCheckoutSteps(history, location, t);
        }
        hideModal('ONLINE_CHECKOUT_MODAL');
    }
    componentDidUpdate() {
        this.redirectToContactInformationIfIncomplete();
    }
    componentWillUnmount() {
        const { checkoutStore: { resetCheckoutStore } } = this.props;
        window.removeEventListener('popstate', this.handleBackButton);
        resetCheckoutStore();
    }
    render() {
        const borrowerEmailValue = borrowerForm.$('email').value.toLowerCase();
        const { t, imagesStore, financingStore, location, history, profileStore, checkoutStore } = this.props;
        const language = (this.props.appStore && this.props.appStore.language) || 'de';
        const { isStepComplete, isLastStep, totalSteps, offerIndex, subStep, registrationServicesOptions, activeStep, readyToRedirect, warrantyPeriod, warrantyPackage, anschlussGarantie, borrowerInformation, showButtonErrorMessage, paymentDetailsOpen, promocodeIsOpen, stepHasError, externalState: { vatRate = 0, carId, mainImageId, make, model, subModel } } = checkoutStore;
        const deliveryInformation = _.cloneDeep(profileStore.selectedDeliveryCheckoutAddressObj);
        if (readyToRedirect) {
            return React.createElement(Redirect, { to: '/search', push: true });
        }
        const offerName = offers[offerIndex].name;
        const financingConfig = financingStore.getUserConfig(carId);
        const { checkout: { admissionService, licensePlateFee, warrantyRates = [] }, [offerName]: { monthlyInstallment, paybackPeriod, firstInstallment, annualMileage }, common: { currentSalesPrice } } = financingConfig;
        const mainImageUrl = imagesStore.getSupportedImageFormat(carId, mainImageId, 'small');
        const warrantyRate = (warrantyPackage == null || warrantyPackage === 3) ? 0 : warrantyRates[warrantyPackage];
        // Rundum-Sorglos-Paket (withAddServices) is NOT added here — see the same comment in
        // renderContent above; already baked into monthlyInstallment (financing/leasing) — Buy now
        // reads the plain currentSalesPrice instead, see headerProps.price's own comment below.
        const checkoutTotalCost = warrantyRate + +registrationServicesOptions[0] * admissionService + +registrationServicesOptions[1] * licensePlateFee
            + getAnschlussGarantiePrice(anschlussGarantie, financingConfig, offerIndex);
        const headerProps = {
            // ADV-299: matches the CDP's own rate exactly (CheckoutHeaderNext/CheckoutAsideNext/
            // OrderOverviewNext's headline all read this same value) — checkoutTotalCost (warranty +
            // registration/plate fees + Rundum-Sorglos + Anschluss-Garantie) is real cost the customer
            // still owes, but it's shown itemized in step 5's own breakdown instead of silently baked
            // into the one number that's meant to be directly comparable to the CDP everywhere else.
            // Buy: currentSalesPrice, not currentSalesPriceExtra — same fix/reasoning as
            // orderOverviewProps.price above (Rundum-Sorglos-Paket double-counted otherwise).
            checkoutStore, t, carId, mainImageUrl, model, subModel, make, vatRate, price: (offerIndex === 3 ? currentSalesPrice : monthlyInstallment),
            activeScroll: true
        };
        // .co-aside-amount specifically (not the header) reflects the selected Anschluss-Garantie
        // price — same +15/+9 figures as additional-services' own .co-anschluss-price-value, and
        // order-overview's "Monatliche Gesamtbelastung" (mzzTotal, OrderOverviewNext.tsx), so the
        // aside's own total stays in sync with it instead of silently dropping back to the bare
        // monthlyInstallment once the customer reaches the final confirmation step. Not folded into
        // headerProps.price itself — contact-information/payment-type/payment-details (before
        // Anschluss-Garantie is even chosen, anschlussGarantie still null) stay on the ADV-299
        // CDP-matching figure untouched, same as before; getAnschlussGarantiePrice already returns 0
        // for a null selection, so this is a no-op on those earlier steps regardless.
        const pathname = checkoutStore.steps[activeStep] && checkoutStore.steps[activeStep].pathname;
        const showsAnschlussGarantieInAside = pathname === 'additional-services' || pathname === 'order-overview';
        const asidePrice = headerProps.price + (showsAnschlussGarantieInAside ? getAnschlussGarantiePrice(anschlussGarantie, financingConfig, offerIndex) : 0);
        const links = t('CheckoutPage:footer', { returnObjects: true });
        const priceEvaluationDateObj = new Date();
        const priceEvaluationDate = `${priceEvaluationDateObj.getDate()}.${priceEvaluationDateObj.getMonth() + 1}.${priceEvaluationDateObj.getFullYear()}`;
        const step = activeStep === totalSteps() - 2 && subStep ? activeStep + 10 : activeStep;
        const contactInformationEmail = form.$('email').value;
        const buttonHasErrorMessage = stepHasError(activeStep, subStep);
        const buttonNextProps = {
            checkoutStore, t, borrowerEmailValue,
            financingConfig, borrowerInformation, borrowerForm, deliveryInformation, warrantyPeriod,
            formHasError: form.hasError, borrowerFormHasError: borrowerForm.hasError, deliveryFormHasError: deliveryForm.hasError,
            orderOverviewFormHasError: orderOverviewForm.hasError,
            profileStore: profileStore,
            showButtonErrorMessage,
            paymentDetailsOpen,
            contactInformationEmail,
            buttonHasErrorMessage,
            promocodeIsOpen
            // handleAccordionDelivery: this.handleAccordionDelivery
        };
        const contentWrapperClasses = classnames(styles.contentWrapper, { [styles.orderContentWrapper]: isLastStep() }, styles.nextLayout);
        return (React.createElement(Page, { page: 'CHECKOUT_PAGE', className: styles.page, showCrumbs: false, mainContentClass: styles.mainContentWrap },
            React.createElement(React.Fragment, null,
                React.createElement(CheckoutTopBarNext, { checkoutStore: checkoutStore, t: t, carId: carId }),
                React.createElement(CheckoutHeaderNext, { ...headerProps, language: language }),
                React.createElement("div", { className: contentWrapperClasses },
                    React.createElement(CheckoutMobilePageTitle, { checkoutStore: checkoutStore }),
                    !isMobileOnly && React.createElement(CheckoutStepperNext, { checkoutStore: checkoutStore, t: t }),
                    React.createElement("div", { className: styles.contentContainer },
                        this.renderContent(step),
                        React.createElement(CheckoutButtonNext, { ...buttonNextProps })),
                    !isMobileOnly
                        ? React.createElement(CheckoutAsideNext, { checkoutStore: checkoutStore, t: t, language: language, price: asidePrice, mainImageUrl: mainImageUrl, make: make, model: model, subModel: subModel, vatRate: vatRate, offerIndex: offerIndex, term: paybackPeriod, downPayment: firstInstallment, annualMileage: annualMileage, financingConfig: financingConfig })
                        : null),
                React.createElement("footer", { className: "co-footer" },
                    React.createElement("div", { className: "co-footer-inner" },
                        React.createElement("p", { dangerouslySetInnerHTML: { __html: t('footer:vatReportable') } }),
                        React.createElement("p", { dangerouslySetInnerHTML: { __html: t('footer:manufacturerUvp') } }),
                        React.createElement("p", { dangerouslySetInnerHTML: { __html: t('footer:uvpComparisonRate') } }),
                        React.createElement("p", { dangerouslySetInnerHTML: { __html: t('footer:priceEvaluation', { date: priceEvaluationDate }) } }),
                        React.createElement("p", { dangerouslySetInnerHTML: { __html: t('footer:vehicleImages') } })),
                    React.createElement("div", { className: "co-footer-bottom" },
                        React.createElement("div", { className: "co-footer-bottom-inner" },
                            React.createElement("div", { className: "co-footer-left" },
                                React.createElement("a", { href: "#", className: "co-footer-link" }, t('footer:links.imprint')),
                                React.createElement("a", { href: "#", className: "co-footer-link" }, t('footer:links.conditions')),
                                React.createElement("a", { href: "#", className: "co-footer-link" }, t('footer:links.dataProtection'))),
                            React.createElement("div", { className: "co-footer-right" },
                                React.createElement("span", { className: "co-footer-copyright" },
                                    "\u00A9 ",
                                    t('footer:copyright', { year: new Date().getFullYear() })),
                                React.createElement("button", { type: "button", className: "co-footer-up", onClick: () => window.scrollTo({ top: 0, behavior: 'smooth' }) },
                                    t('footer:up'),
                                    " \u2191"))))),
                React.createElement(ModalOverlay, { location: location }))));
    }
};
CheckoutPage = __decorate([
    inject('financingStore', 'authStore', 'profileStore', 'appStore', 'imagesStore', 'carStore', 'checkoutStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], CheckoutPage);
export default translate(['CheckoutPage', 'modals', 'VehicleDetailsPage'])(CheckoutPage);
